import { EventBus } from '~/lib/event_bus';

export function notFoundInterceptor(error) {
  if (error.response?.status === 404 ) {
    EventBus.emit('banner-event', { message: error.response.data.errors[0].detail, messageType: 'alarm' });
  }
  return Promise.reject(error);
}
